import { Modal } from '@material-ui/core';
import React from 'react';

import Footer from './components/ModalFooter';
import Header from './components/ModalHeader';
import Body from './components/ModalBody';
import CustomBackdrop from './components/CustomBackdrop';
import Container from './components/Container';

class CustomModal extends React.Component {
  static Header = ({ children, ...props }) => (
    <Header {...props}>{children}</Header>
  );
  static Footer = ({ children, ...props }) => (
    <Footer {...props}>{children}</Footer>
  );
  static Body = ({ children, ...props }) => <Body {...props}>{children}</Body>;

  render() {
    const { open, handleClose, children } = this.props;
    return (
      <Modal
        aria-labelledby="modal-main"
        aria-describedby="main-modal"
        open={open}
        onClose={handleClose}
        BackdropComponent={CustomBackdrop}
      >
        <Container>
          {typeof children === 'function' ? children() : children}
        </Container>
      </Modal>
    );
  }
}

export default CustomModal;
